import { ActionType } from 'typesafe-actions';
import * as drawersActionCreators from './actions';
import reducer from './reducer';

export default reducer;

export const actions = drawersActionCreators;

export * from './types';
export type DrawersActions = ActionType<typeof drawersActionCreators>;
